import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import SEO from "../components/SEO";
import api, { getFullImageUrl } from "../services/api";

const formatDate = (value) => new Intl.DateTimeFormat("vi-VN", {
  day: "2-digit", month: "long", year: "numeric",
}).format(new Date(value));

export default function ArticleDetail() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    api.get(`/articles/${encodeURIComponent(slug)}`)
      .then((response) => setArticle(response.data))
      .catch(() => setError("Không tìm thấy bài viết này."))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="min-h-screen bg-slate-50 dark:bg-slate-950" style={{ zoom: "0.8" }}><Navbar /><div className="pt-44 max-w-4xl mx-auto px-4"><div className="h-[32rem] bg-white dark:bg-slate-900 rounded-3xl animate-pulse" /></div></div>;
  if (error || !article) return <div className="min-h-screen bg-slate-50 dark:bg-slate-950" style={{ zoom: "0.8" }}><Navbar /><main className="pt-44 pb-24 text-center"><h1 className="text-3xl font-black dark:text-white">{error}</h1><Link to="/articles" className="inline-flex mt-6 text-indigo-600 font-bold">← Quay lại bài viết</Link></main></div>;

  return <div className="min-h-screen bg-slate-50 dark:bg-slate-950" style={{ zoom: "0.8" }}>
    <SEO title={article.title} description={article.excerpt} image={article.images?.[0] ? getFullImageUrl(article.images[0]) : undefined} />
    <Navbar />
    <main className="pt-28 sm:pt-40 pb-24 px-4">
      <article className="max-w-4xl mx-auto">
        <Link to="/articles" className="inline-flex text-sm font-bold text-indigo-600 hover:text-indigo-800">← Tất cả bài viết</Link>
        <header className="mt-7 text-center">
          <div className="flex flex-wrap justify-center gap-2">{article.hashtags?.slice(0,5).map((tag) => <span key={tag} className="px-3 py-1 bg-indigo-50 text-indigo-700 rounded-full text-xs font-bold">#{String(tag).replace(/^#/, "")}</span>)}</div>
          <h1 className="mt-5 text-3xl sm:text-5xl font-black text-slate-950 dark:text-white tracking-tight leading-tight">{article.title}</h1>
          <time className="mt-5 block text-sm text-slate-500">Đăng ngày {formatDate(article.publishedAt)}</time>
        </header>
        {article.images?.[0] ? <img src={getFullImageUrl(article.images[0])} alt={article.title} className="mt-10 w-full max-h-[620px] object-cover rounded-3xl shadow-xl" /> : null}
        <div className="mt-10 p-7 sm:p-12 bg-white dark:bg-slate-900 rounded-3xl border border-slate-100 dark:border-slate-800 shadow-sm">
          <div className="whitespace-pre-wrap text-base sm:text-lg leading-8 text-slate-700 dark:text-slate-200">{article.body}</div>
          {article.images?.slice(1).map((image, index) => <img key={image} src={getFullImageUrl(image)} alt={`${article.title} ${index + 2}`} className="mt-8 w-full rounded-2xl" />)}
        </div>
      </article>
    </main>
  </div>;
}
